
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectorGoingTo as ObiConnectorGoingToElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connector-going-to.js';
 
 
 

 
 export const ObiConnectorGoingTo = createComponent({
   react: React,
   tagName: 'obi-connector-going-to',
   elementClass: ObiConnectorGoingToElement,
   events: {
     
   }
  });
 
 